import styled from 'styled-components';

export const DescriptionWrapper = styled.div`
  display: flex;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.baseBlue.a6};
`;

export const EntityTitle = styled.div`
  width: 345px;
  padding-bottom: 5px;
  padding-top: 30px;
`;

export const TopicQuestionTitle = styled.div`
  border-left: 1px solid ${({ theme }) => theme.black.a1};
  padding: 0 0 5px 15px;
`;

export const TableHeader = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  padding-top: 30px;
`;
